import _sfc_main from "./SidebarElement.vue2.js";
import "./SidebarElement.vue3.js";
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const SidebarElement = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-f0b895c5"]]);
export {
  SidebarElement as default
};
//# sourceMappingURL=SidebarElement.vue.js.map
